import React from 'react'
import axios from 'axios'
import './application-info-gutter.css'
import { baseUrl } from '../../../assets/Animations'
import { getRequestHeaders } from '../../../api'
import { MdCheck, MdClose } from 'react-icons/md'
import { InstrumentChip } from '../../../NewStudentForm/AutoFillNewStudentForm/InstrumentChip/InstrumentChip'
const ApplicationInfoGutter = ({applicationId}) => {
    const [application, setApplication] = React.useState({})

    const formattedApplication = [
        {label: 'Email', info: application.key3app, isWideLabel: false, isCheckMark: false, chips: false},
        {label: 'Instruments', info: application.key13app, isWideLabel: false, isCheckMark: false, chips: true},
        {label: 'Areas', info: application.key22app, isWideLabel: false, isCheckMark: false, chips: false},
        {label: 'Experience', info: `${application.key6app} Years`, isWideLabel: false, isCheckMark: false, chips: false},
        {label: 'Previous Experience', info: application.key7app, isWideLabel: false, isCheckMark: true, chips: false},
        {label: 'Background Check', info: application.key17app, isWideLabel: false, isCheckMark: true, chips: false},
        {label: 'Has Vehicle', info: application.key18app, isWideLabel: false, isCheckMark: true, chips: false},
        {label: 'Has Driver\'s License', info: application.key19app, isWideLabel: false, isCheckMark: true, chips: false},
        {label: 'Desired Studio Size', info: `${application.key9app} Students`, isWideLabel: false, isCheckMark: false, chips: false},
        {label: 'Link', info: application.key20app, isWideLabel: true, isCheckMark: false, chips: false},
        {label: 'Education', info: application.key11app, isWideLabel: true, isCheckMark: false, chips: false},
    ]

    React.useEffect(() => {
        getApplication()
    }, [])

    const getApplication = async () => {
        if(applicationId) {
            axios.get (`${baseUrl}/applications/${applicationId}`, getRequestHeaders())
            .then(res => setApplication(res.data))
            .catch(err => console.log(err))
        } else {
            return
        }
    }

    if(application) {
        return (
            <div className='application-gutter__wrapper'>
                {formattedApplication?.map((item, index) => {
                    if(item.isCheckMark) {
                        return (
                            <div key={index} className='application-gutter__each-section__checkmark'>
                                {item.info === "true" ? <MdCheck color='#14B8A6' size={17} /> : <MdClose color='#FF5C5C' size={17} />}
                                <div className='application-gutter__info'>{item.label}</div>
                            </div>
                        )
                    } else if (item.chips) {
                        return (
                            <div key={index} className='application-gutter__each-section__chips'>
                                <div className='application-gutter__label'>{item.label}</div>
                                <div className='application-gutter__info__inst-wrappers'>{item.info?.map((instrument, index) =>  <div className='application-gutter__info__inst-chip' key={instrument.id}>{instrument.name}</div>)}</div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div key={index} className='application-gutter__each-section'>
                                {
                                item.isWideLabel ? 
                                    <div className='application-gutter__label__wide-label'>
                                        <div className='application-gutter__label__wide-label__line'></div>
                                        <div className='application-gutter__label__wide-label__label'>{item.label.toUpperCase()}</div>
                                        <div className='application-gutter__label__wide-label__line'></div>
                                    </div> 
                                :
                                <div className='application-gutter__label'>{item.label}</div>}
                                <div className='application-gutter__info'>{item.info}</div>
                            </div>
                        )
                    }
                })}
            </div>
        )
    } else {
        return (
            <div>no application</div>
        )
    }
}
export default ApplicationInfoGutter